import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import axiosApiInstance from "@/api/authorization/auth-request-api";
import { repairSpace } from "./check_url";
import { getWebImage as pics } from "@/config/host.config";

export function getWebImage(name: string, folder: string): string {
  let image = `${pics}/pics/${folder}/${name}`;
  if (image) {
    image = repairSpace(image);
  }
  return image;
}

export async function downloadImage(
  url: string,
  imageName: string,
  path: string
): Promise<Blob> {
  const urlImage = url + "/" + imageName;
  const config: AxiosRequestConfig = {
    responseType: "blob",
    params: { path: path },
  };
  return new Promise<Blob>((res, rej) => {
    axiosApiInstance
      .get(urlImage, config)
      .then((image: AxiosResponse) => {
        if (image.status === 200) {
          res(image.data);
        }
      })
      .catch((error: AxiosError) => {
        rej(error);
      });
  });
}

export function getImage(name: string, folder: string | null): string | null {
  let image: string | null = null;
  try {
    if (folder) image = require(`@/assets/img/${folder}/${name}`);
    else image = require(`@/assets/img/${name}`);

    if (image) image = repairSpace(image);
  } catch (e) {
    console.log(`Cannot find module: @/assets/img/${folder}/${name} `);
  }
  return image;
}

export function getFolder(width: number): string {
  return width == 0
    ? "origin"
    : width <= 375
    ? "375"
    : width <= 576
    ? "576"
    : width <= 768
    ? "768"
    : width <= 992
    ? "992"
    : width <= 1200
    ? "1200"
    : "origin";
}
